module.exports = __webpack_public_path__ + "img/webcam-security-001.c5755947.jpg";